import { call, put } from 'redux-saga/effects'
import { AuditActionCreators } from 'app/reducers/AuditRedux'
import { Audit } from 'app/services/api/entities'

export function* refreshPasswordRequirements() {
  try {
    yield put(AuditActionCreators.refreshPasswordRequirementsRequest())

    const response = yield call(Audit.getPasswordRequirements)

    if (response.status === 200) {
      const { securityPolicy } = response.data
      if (securityPolicy) {
        const changeDashboardPass = securityPolicy.needDashboardPasswordChange
        const changeMailboxPass = securityPolicy.needEmailPasswordChange
        yield put(AuditActionCreators.refreshPasswordRequirementsSuccess(
          changeDashboardPass || false,
          changeMailboxPass || false
        ))
        return
      }

      yield put(
        AuditActionCreators.refreshPasswordRequirementsSuccess(
          false,
          false
        )
      )
    } else {
      yield put(AuditActionCreators.refreshPasswordRequirementsFailure(response.data))
    }
  } catch (error) {
    yield put(AuditActionCreators.refreshPasswordRequirementsFailure(error))
  }
}
